import React, { useEffect, useState, useRef } from "react"
import { setCountApi, setLoggedIn, setSearchCount, setSearchValue } from "../../Store/Auth/actions"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { IoNotificationsOutline, IoPowerOutline, IoLanguage, IoImages } from "react-icons/io5";
import { LiaCogSolid } from "react-icons/lia";
import logo from '../../Assets/Images/logo.png'
import { GiHamburgerMenu, GiFamilyTree } from "react-icons/gi";
import { FaHome, FaRegUserCircle, FaSearch, FaUser } from "react-icons/fa";
import { setLanguage } from "../../Store/Theme/actions";
import { useTranslation } from "react-i18next";
import API from '../../Common/API'
import { motion } from 'framer-motion'
import io from "socket.io-client";
import dummy from '../../Assets/Images/dummy.jpg.webp'
import Dialog from '../../Components/Dialog'
import Button from "../../Components/Button"
import mLogo from '../../Assets/Images/logo.jpeg'

const socket = io("https://royalkavery.com:5000", { transports: ['websocket'] });

const TopBar = () => {
    const dispatch = useDispatch()
    const [searchText, setSearchText] = useState('')
    const history = useHistory()
    const [openSettingsMenu, setOpenSettingsMenu] = useState(false);
    const [openLangMenu, setOpenLangMenu] = useState(false)
    const [openNotifications, setOpenNotifications] = useState(false);
    const userDetails = useSelector((state) => state.auth.userDetails)
    const lang = useSelector((state) => state.theme.language)
    const { t } = useTranslation()
    const notifyRef = useRef(null);
    const [notificationList, setNotificationList] = useState([])
    const [notificationCount, setNotificationCount] = useState(0);
    const searchCount = useSelector((state) => state.auth.searchCount)
    const [logoutPopup, setLogoutPopup] = useState(false)
    const [openMobileMenu, setOpenMobileMenu] = useState(false)
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
    const [openMobileNotifications, setOpenMobileNotifications] = useState(false)
    const [openMobileLang, setOpenMobileLang] = useState(false)

    useEffect(() => {
        if (userDetails?._id) {
            socket.emit('join', userDetails._id);
            socket.on('newNotification', () => {
                setNotificationCount(prev => prev + 1);
            });
        }
        getNotificationCount()
        return () => {
            socket.off('newNotification');
        };
    }, [userDetails?._id]);

    const logOut = () => {
        localStorage.clear()
        dispatch(setLoggedIn(false))
        history.push('/')
    }

    const getNotificationCount = async () => {
        try {
            const res = await API.get('/user/getNotificationCount')
            if (res.status === 200) {
                setNotificationCount(res.data.data)
                notifyRef.current = res.data.data
            }
        } catch (err) {
            console.log(err)
        }
    }

    const getNotifications = async () => {
        try {
            const res = await API.get('/user/getNotifications')
            if (res.status === 200) {
                setNotificationList(res.data.data)
                notifyRef.current = res.data.data.length
            }
        } catch (err) {
            console.log(err)
        }
    }

    const changeViewStatus = async (id) => {
        try {
            const res = await API.post('/user/changeNotificationStatus', { notificationId: id })
            if (res.status === 200) {
                getNotificationCount()
                getNotifications()
            }
        } catch (err) {
            console.log(err)
        }
    }

    const searchString = () => {
        dispatch(setSearchCount(searchCount + 1))
        dispatch(setSearchValue(searchText))
    }

    const clearSearch = () => {
        setSearchText('');
        dispatch(setSearchValue(''));
        dispatch(setSearchCount(searchCount + 1))
    }

    return (
        //     <div className="bg-white shadow-md h-20 w-full flex flex-row justify-between items-center relative">
        //         <div
        //             className="bg-primeColor md:w-fit w-full flex flex-row items-center md:flex-col px-2 py-2 justify-between md:justify-center h-full cursor-pointer"
        //             onClick={() => history.push('/home')}
        //         >
        //             <img src={logo} height={100} width={200} alt="logo" />
        //             <div className="md:hidden block items-center justify-center flex h-full px-2" onClick={()=>setOpenMobileMenu(true)}>
        //                 <GiHamburgerMenu className="text-white" size={20} />
        //             </div>
        //         </div>

        //         <div className="hidden md:flex w-96 border border-black items-center space-x-2 rounded-full">
        //             <input
        //                 type="text"
        //                 className="flex-grow ring-none rounded-full outline-none py-2 px-3"
        //                 value={searchText}
        //                 placeholder={t(`Search your partner...`)}
        //                 onChange={(ev) => setSearchText(ev.target.value)}
        //             />
        //             {searchText && <p className="cursor-pointer px-2" onClick={clearSearch}>X</p>}
        //             <p className="bg-primeColor px-5 py-3 text-white rounded-tr-full h-full rounded-br-full drop-shadow-md cursor-pointer" onClick={searchString}><FaSearch size={20} /></p>
        //         </div>



        //         {logoutPopup && (
        //             <Dialog title={t('Logout')} desc={t('Are you sure you want to logout?')}>
        //                 <div className="flex flex-row justify-end gap-5">
        //                     <Button label={t('Cancel')} onClick={() => setLogoutPopup(false)} variant="outline" />
        //                     <Button label={t('Logout')} onClick={logOut} />
        //                 </div>
        //             </Dialog>
        //         )}

        //         {openMobileMenu && (
        //     <motion.div
        //       initial={{ y: -20, opacity: 0 }}
        //       animate={{ y: 0, opacity: 1 }}
        //       transition={{ duration: 0.3 }}
        //       className="absolute top-full left-0 z-50 w-full bg-white border-t border-gray-300 flex flex-col md:hidden shadow-lg"
        //     >
        //       <div className="flex flex-col p-4 space-y-3">
        //         <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => history.push(`/home`)}>Home</button>
        //         <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => history.push(`/profile/manageImages`)}>Manage Images</button>
        //         <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => history.push(`/profile/edit/${userDetails._id}`)}>Edit Profiles</button>
        //         {/* <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => setOpenLangMenu(!openLangMenu)}>Language ({lang})</button> */}
        //         {/* <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => { setOpenNotifications(true); getNotifications(); }}>Notifications</button> */}
        //         {/* <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => setOpenSettingsMenu(true)}>Settings</button> */}
        //         <button className="text-left text-red-600 hover:bg-red-600 hover:text-white px-3 py-2 rounded" onClick={() => setLogoutPopup(true)}>Logout</button>
        //       </div>
        //     </motion.div>
        //   )}
        //     </div>
        <div className="bg-white shadow-md h-20 w-full flex flex-row justify-between items-center relative">
            {/* Left Section */}
            <div
                className="bg-primeColor md:w-fit w-full flex flex-row items-center  px-2 py-2 justify-between md:justify-center h-full cursor-pointer"
                onClick={() => history.push('/home')}
            >
                <div className="flex flex-row items-center gap-2">
                    <img src={mLogo} height={50} width={50} className="mx-2" />
                <img
                    src={logo}
                    alt="logo"
                    className="w-[100px] md:w-[200px] h-auto"
                />
                </div>
                <motion.div className="flex flex-row gap-1">
                    <div
                        className="md:hidden block items-center justify-center flex h-full px-2"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpenMobileNotifications(!openMobileNotifications);
                        }}
                    >
                        <IoNotificationsOutline className="text-white" size={20} />
                    </div>
                    <div
                        className="md:hidden block items-center justify-center flex h-full px-2"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpenMobileLang(!openMobileLang);
                        }}
                    >
                        <IoLanguage size={20} color="white" />
                    </div>
                    <div
                        className="md:hidden block items-center justify-center flex h-full px-2"
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsMobileMenuOpen(!isMobileMenuOpen);
                        }}
                    >
                        <GiHamburgerMenu className="text-white" size={20} />
                    </div>
                </motion.div>
            </div>

            {/* Search Bar (hidden in mobile) */}
            <div className="hidden md:flex w-96 border border-black items-center space-x-2 rounded-full">
                <input
                    type="text"
                    className="flex-grow ring-none rounded-full outline-none py-2 px-3"
                    value={searchText}
                    placeholder={t(`Search your partner...`)}
                    onChange={(ev) => setSearchText(ev.target.value)}
                />
                {searchText && <p className="cursor-pointer px-2" onClick={clearSearch}>X</p>}
                <p className="bg-primeColor px-5 py-3 text-white rounded-tr-full h-full rounded-br-full drop-shadow-md cursor-pointer" onClick={searchString}><FaSearch size={20} /></p>
            </div>

            {/* Desktop Menu */}
            <div className="md:flex hidden flex-row justify-start gap-5 px-5 relative">
                <div className="flex md:flex hidden flex-row justify-start gap-5 px-5 relative">
                    {/* Home Icon */}
                    <div className="w-fit h-fit flex bg-primeColor/30 hover:bg-primeColor hover:text-white cursor-pointer px-2 py-2 rounded-full" onClick={() => history.push(`/home`)}>
                        <FaHome size={25} title="Go to home" />
                    </div>
                    {/* Language Menu */}
                    <div className="relative">
                        <div className="w-fit h-fit flex bg-primeColor/30 hover:bg-primeColor hover:text-white cursor-pointer px-2 py-2 rounded-full" onClick={() => { setOpenLangMenu(!openLangMenu); setOpenSettingsMenu(false); }}>
                            <IoLanguage size={25} />
                        </div>
                        <span className="absolute -top-3 drop-shadow-md w-7 h-7 -right-4 bg-white rounded-full text-sm flex items-center justify-center">{lang || 'en'}</span>
                        {openLangMenu && (
                            <div className="absolute top-full mt-2 right-0 w-32 bg-white shadow-lg rounded-md py-2 z-50">
                                <p className="text-sm text-gray-700 py-2 px-2 cursor-pointer hover:bg-primeColor hover:text-white" onClick={() => { dispatch(setLanguage('en')); setOpenLangMenu(false) }}>English</p>
                                <p className="text-sm text-gray-700 py-2 px-2 cursor-pointer hover:bg-primeColor hover:text-white" onClick={() => { dispatch(setLanguage('ta')); setOpenLangMenu(false) }}>Tamil</p>
                            </div>
                        )}
                    </div>
                    {/* Image Icon */}
                    <div className="w-fit h-fit flex bg-primeColor/30 hover:bg-primeColor hover:text-white cursor-pointer px-2 py-2 rounded-full" onClick={() => history.push(`/profile/manageImages`)}>
                        <IoImages size={25} title="Manage Images" />
                    </div>
                    {/* Notification Icon */}
                    <div className="relative" ref={notifyRef}>
                        <div className="w-fit h-fit flex bg-primeColor/30 hover:bg-primeColor hover:text-white cursor-pointer px-2 py-2 rounded-full" onClick={() => { setOpenNotifications(!openNotifications); setOpenSettingsMenu(false); getNotifications() }}>
                            <IoNotificationsOutline size={25} />
                            {notificationCount > 0 && (
                                <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">{notificationCount}</span>
                            )}
                        </div>
                        {openNotifications && (
                            <div className="absolute top-full mt-2 right-0 w-96 h-96 flex overflow-auto bg-white shadow-lg rounded-md z-50">
                                <div className="flex flex-col px-2 py-2">
                                    <p className="text-lg font-bold">Notifications</p>
                                    {notificationList.length > 0 ? notificationList.map((item, index) => (
                                        <div key={index} className={`flex ${!item.isViewed ? 'bg-primeColor/20' : ''} items-center w-full hover:bg-white cursor-pointer px-2 py-2 gap-5`} onClick={() => { setOpenNotifications(false); changeViewStatus(item._id); history.push(item.redirectUrl) }}>
                                            <div className="w-10 h-10 rounded-full bg-primeColor/30 flex flex-col items-center justify-center">
                                                <img src={item.imageUrl || dummy} className="w-10 h-10 rounded-full" alt="notification" />
                                            </div>
                                            <div className="flex flex-col w-full">
                                                <p>{item.notificationMessage}</p>
                                                {item.notificationType === 'PROFILE_DOWNLOAD' && <motion.div className="cursor-pointer text-primeColor font-bold text-lg underline" onClick={() => { setOpenNotifications(false); changeViewStatus(item._id); history.push(item.redirectUrl) }}>View Profile</motion.div>}
                                            </div>
                                        </div>
                                    )) : <div className="flex flex-col px-2 py-2">
                                        <div className="flex flex-col">
                                            <p className="text-gray-500">{t(`You have no new notifications.`)}</p>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        )}
                    </div>
                    {/* Settings Icon */}
                    <div className="relative">
                        <div className="w-fit h-fit flex bg-primeColor/30 hover:bg-primeColor hover:text-white cursor-pointer px-2 py-2 rounded-full" onClick={() => { setOpenSettingsMenu(!openSettingsMenu); setOpenNotifications(false); }}>
                            <LiaCogSolid size={25} />
                        </div>
                        {openSettingsMenu && (
                            <div className="absolute top-full mt-5 right-0 w-48 py-2 flex flex-col bg-white shadow-lg rounded-md z-50">
                                <div className="text-sm hover:bg-primeColor/30 hover:text-white flex items-center gap-2 font-bold px-2 py-1 text-gray-700 cursor-pointer" onClick={() => { history.push(`/fullProfile/${userDetails._id}`); setOpenSettingsMenu(false) }}><FaRegUserCircle /> <p>{t('View My Profile')}</p></div>
                                <div className="text-sm hover:bg-primeColor/30 hover:text-white flex items-center gap-2 font-bold px-2 py-1 text-gray-700 cursor-pointer" onClick={() => { history.push(`/profile/edit/${userDetails._id}`); setOpenSettingsMenu(false) }}><FaUser /> <p>{t('Edit Profile')}</p></div>
                                {/* <div className="text-sm hover:bg-primeColor/30 hover:text-white flex items-center gap-2 font-bold px-2 py-1 text-gray-700 cursor-pointer" onClick={() => { history.push(`/user/familyHistory/${userDetails._id}`); setOpenSettingsMenu(false) }}><GiFamilyTree className="rotate-180" /> <p>{t('Family History')}</p></div> */}
                                <div className="text-sm hover:bg-primeColor/30 hover:text-white flex items-center gap-2 font-bold px-2 py-1 text-gray-700 cursor-pointer" onClick={() => setLogoutPopup(true)}><IoPowerOutline /> <p>{t('Logout')}</p></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Mobile Menu - Slide Down */}
            {isMobileMenuOpen && (
                <motion.div
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.3 }}
                    className="absolute top-full left-0 z-50 w-full bg-white border-t border-gray-300 flex flex-col md:hidden shadow-lg"
                >
                    <div className="flex flex-col p-4 space-y-3">
                        <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => { history.push(`/home`); setIsMobileMenuOpen(false) }}>{t('Home')}</button>
                        <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => { history.push(`/fullProfile/${userDetails._id}`); setIsMobileMenuOpen(false) }}>{t('View My Profile')}</button>
                        <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => { history.push(`/profile/manageImages`); setIsMobileMenuOpen(false) }}>{t('Manage Images')}</button>
                        <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => { history.push(`/profile/edit/${userDetails._id}`); setIsMobileMenuOpen(false) }}>{t('Edit Profile')}</button>
                        <button className="text-left text-black hover:bg-primeColor hover:text-white px-3 py-2 rounded" onClick={() => { history.push(`/profileHistory`); setIsMobileMenuOpen(false) }}>{t('Histroy')}</button>
                        <button className="text-left text-red-600 hover:bg-red-600 hover:text-white px-3 py-2 rounded" onClick={() => { setLogoutPopup(true); setIsMobileMenuOpen(false) }}>{t('Logout')}</button>
                    </div>
                </motion.div>
            )}

            {openMobileNotifications && (
                <motion.div
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.3 }}
                    className="absolute top-full left-0 z-50 w-full bg-white border-t border-gray-300 flex flex-col md:hidden shadow-lg"
                >
                    <div className="flex flex-col px-2 py-2">
                        <p className="text-lg font-bold">Notifications</p>
                        {notificationList.length > 0 ? notificationList.map((item, index) => (
                            <div key={index} className={`flex ${!item.isViewed ? 'bg-primeColor/20' : ''} hover:bg-white cursor-pointer px-2 py-2 gap-5`} onClick={() => { setOpenNotifications(false); changeViewStatus(item._id); history.push(item.redirectUrl) }}>
                                <div className="w-20 h-20 rounded-full bg-primeColor/30 flex items-center justify-center">
                                    <img src={item.imageUrl || dummy} alt="notification" />
                                </div>
                                <div className="flex flex-col">
                                    <p>{item.notificationMessage}</p>
                                    {item.notificationType === 'PROFILE_DOWNLOAD' && <motion.div className="cursor-pointer text-primeColor font-bold text-lg underline" onClick={() => { setOpenNotifications(false); changeViewStatus(item._id); history.push(item.redirectUrl) }}>View Profile</motion.div>}
                                </div>
                            </div>
                        )) : (<div className="flex flex-col px-2 py-2">
                            <div className="flex flex-col">
                                <p className="text-gray-500">{t(`You have no new notifications.`)}</p>
                            </div>
                        </div>)}
                    </div>
                </motion.div>
            )}

            {openMobileLang && (
                <motion.div
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.3 }}
                    className="absolute top-full left-0 z-50 w-full bg-white border-t border-gray-300 flex flex-col md:hidden shadow-lg"
                >
                    <p className="text-sm text-gray-700 py-2 px-2 cursor-pointer hover:bg-primeColor hover:text-white" onClick={() => { dispatch(setLanguage('en')); setOpenMobileLang(false) }}>English</p>
                    <p className="text-sm text-gray-700 py-2 px-2 cursor-pointer hover:bg-primeColor hover:text-white" onClick={() => { dispatch(setLanguage('ta')); setOpenMobileLang(false) }}>தமிழ்</p>
                </motion.div>
            )}

            <Dialog title={'Confirm Logout'} showDialog={logoutPopup} onClose={() => { setLogoutPopup(false); }}>
                <motion.div className="h-full w-full flex flex-col gap-5 px-2 py-2">
                    <p>{t('Are you sure you want to logout?')}</p>
                    <motion.div className="flex justify-center gap-2">
                        <Button type="primary" injectClass="rounded-md" onClick={() => logOut()}>
                            {t('Yes')}
                        </Button>
                        <Button type="secondary" injectClass="rounded-md" onClick={() => { setLogoutPopup(false) }}>
                            {t('No')}
                        </Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </div>
    )
}

export default TopBar;